var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1731 369L1731 397",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1731.5,
    cy: 364.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1728.1 373C1727.64 373 1727.24 372.834 1726.9 372.501C1726.57 372.168 1726.4 371.768 1726.4 371.3C1726.4 370.833 1726.57 370.432 1726.9 370.099C1727.24 369.766 1727.64 369.6 1728.1 369.6C1728.57 369.6 1728.97 369.766 1729.31 370.099C1729.64 370.432 1729.81 370.833 1729.81 371.3C1729.81 371.768 1729.64 372.168 1729.31 372.501C1728.97 372.834 1728.57 373 1728.1 373ZM1736.61 373C1736.14 373 1735.74 372.834 1735.41 372.501C1735.08 372.168 1734.91 371.768 1734.91 371.3C1734.91 370.833 1735.08 370.432 1735.41 370.099C1735.74 369.766 1736.14 369.6 1736.61 369.6C1737.08 369.6 1737.48 369.766 1737.81 370.099C1738.15 370.432 1738.31 370.833 1738.31 371.3C1738.31 371.768 1738.15 372.168 1737.81 372.501C1737.48 372.834 1737.08 373 1736.61 373ZM1727.38 359.4L1729.42 363.65H1735.38L1737.72 359.4H1727.38ZM1726.57 357.7H1739.12C1739.45 357.7 1739.7 357.845 1739.87 358.136C1740.04 358.426 1740.04 358.72 1739.89 359.018L1736.87 364.457C1736.71 364.741 1736.5 364.96 1736.24 365.116C1735.98 365.272 1735.69 365.35 1735.38 365.35H1729.04L1728.1 367.05H1738.31V368.75H1728.1C1727.47 368.75 1726.98 368.47 1726.66 367.911C1726.33 367.351 1726.32 366.795 1726.62 366.242L1727.76 364.16L1724.7 357.7H1723V356H1725.77L1726.57 357.7Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping1);
export default __webpack_public_path__ + "static/media/shopping_1.b6809a594cf668993c465b65d4404984.svg";
export { ForwardRef as ReactComponent };